import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Avatar, Menu, Dropdown, Icon, Badge, message, Button } from 'antd'
import { DownOutlined } from '@ant-design/icons';
import { useMount } from 'react-use'
import cn from 'classnames'
import { NavLink, useHistory } from 'react-router-dom'
import * as userSelector from '@/models/user/selectors'
import * as notifySelector from '@/models/notifies/selectors'
import { logout, getCurrentUser } from '@/models/user/actions'
import * as managerActions from '@/models/managers/actions'
import * as globalSearchActions from '@/models/globalSearch/actions'
import * as tenantAction from '@/models/tenants/actions'
import * as couponsAction from '@/models/coupons/actions'
import styles from './styles.module.scss'
import getNavs from '@/navs'
import * as apis from '@/apis'
import { BellTwoTone } from '@ant-design/icons';
import { fetchedNotify } from '@/models/notifies/actions'
const { SubMenu } = Menu;
const checkActive = nav => {
  const reg = new RegExp(`^${nav.to}`)
  return (_, location) => reg.test(location.pathname)
}

let firstCheckWorkingLock = false

export default function Header() {
  const [navs, setNavs] = useState([])
  const user = useSelector(userSelector.getCurrentUser)
  const notifyCount = useSelector(notifySelector.notifyCountSelector)
  const dispatch = useDispatch()
  const history = useHistory();
  const logoutHandler = useCallback(() => dispatch(logout({ history })))
  const tenant = process.env.APP_MODE === 'tenant' && user.getIn(['staff', 'tenant'])
  //const tenantId = process.env.APP_MODE === 'tenant' && user.getIn(['staff', 'tenant', '_id'])
  const setManagerWorkingState = useCallback(() => {
    const id = user.getIn(['manager', '_id'])
    const isWorking = user.getIn(['manager', 'isWorking'])
    apis.setWorkingState(id, {
      isWorking: !isWorking
    }).then(() => {
      if (isWorking) {
        message.info('已停止接单')
      } else {
        message.success('已开始接单')
      }

      dispatch(getCurrentUser())
      dispatch(managerActions.updated(id, { isWorking: !isWorking }))
    })
      .catch(error => {
        message.error(error.message || '设置失败')
      })
  }, [user])
  const showTenantDialog = useCallback(() => {
    dispatch(tenantAction.showInfoDialog({
      id: tenant?._id
    }))
  })
  const showCouponsDialog = useCallback(() => {
    dispatch(couponsAction.showInfoDialog({
    }))
  })
  const showGlobalSearch = useCallback(() => {
    dispatch(globalSearchActions.toggleDialog())
  })
  useMount(() => {
    if (
      !firstCheckWorkingLock &&
      process.env.APP_MODE !== 'tenant' &&
      user.getIn(['manager', 'isWorking']) === false
      // TODO 管理员无需提醒
    ) {
      // setTimeout(() => {
      //   message.info('您还未开始接单，请记得开启', 5)
      // }, 1000)
    }
    firstCheckWorkingLock = true
    if (tenant) {
      dispatch(fetchedNotify());
    }
  })

  useEffect(() => {
    const navs = getNavs(user.toJS())
    setNavs(navs)
  }, [user])

  const navToNotify = useCallback(() => {
    history.push('/notifyCenter')
  })
  const menu = (
    <Menu>
      {
        process.env.APP_MODE !== 'tenant' && user.get('manager') && !user.get('isTouer') && (
          <Menu.Item onClick={setManagerWorkingState} className={styles.dropDownMenuItem}>
            <Icon type="smile" style={{ fontSize: 18, marginRight: 6 }} />
            <span>{user.getIn(['manager', 'isWorking']) ? '停止接单' : '开始接单'}</span>
          </Menu.Item>
        )
      }
      <Menu.Item onClick={logoutHandler} className={styles.dropDownMenuItem}>
        <Icon type="logout" style={{ fontSize: 18, marginRight: 6 }} />
        <span>退出登录</span>
      </Menu.Item>
      {
        process.env.APP_MODE == 'tenant' && user.get('isTouer') &&
        <Menu.Item onClick={showTenantDialog} className={styles.dropDownMenuItem}>
          <Icon type="profile" style={{ fontSize: 18, marginRight: 6 }} />
          <span>企业信息</span>
        </Menu.Item>
      }
      {
        process.env.APP_MODE == 'tenant' &&
        <Menu.Item onClick={showCouponsDialog} className={styles.dropDownMenuItem}>
          <Icon type="profile" style={{ fontSize: 18, marginRight: 6 }} />
          <span>代金券</span>
        </Menu.Item>
      }
    </Menu>
  )
  // return null

  return (
    <div className={styles.header}>
      <a href="/" className={styles.logo}>
        <img src={process.env.PUBLIC_URL + `/logo.jpeg`} alt="" />
        <h1>小兵速帮</h1>
        <div className={cn(styles.app_mode, styles[process.env.APP_MODE])}>
          {
            process.env.APP_MODE === 'tenant' ? '租户端' : '管理端'
          }
        </div>
      </a>
      {
        tenant?.short_name && <div className={styles.tenantName}><span>{tenant?.short_name}</span></div>
      }
      <Menu mode="horizontal">
        {
          navs.map(nav => {
            if (nav.children && nav.children.length > 0) {
              return <SubMenu key={nav.name} title={nav.name}>
                {nav.children.map(child => (
                  <Menu.Item key={child.name}> <NavLink
                    key={child.to}
                    to={child.to}
                    exact={child.exact}
                    strict={child.strict}
                    activeClassName={styles.active}
                    className={styles.navItem}
                    isActive={child.isActive || checkActive(child)}>
                    {child.name}
                  </NavLink></Menu.Item>
                ))
                }
              </SubMenu>
            } else {
              return <Menu.Item key={nav.name}>
                <NavLink
                  key={nav.to}
                  to={nav.to}
                  exact={nav.exact}
                  strict={nav.strict}
                  activeClassName={styles.active}
                  className={styles.navItem}
                  isActive={nav.isActive || checkActive(nav)}>
                  {nav.name}
                </NavLink></Menu.Item>
            }
          })
        }
      </Menu>
      <Button
        onClick={showGlobalSearch}
        style={{ marginRight: 5 }}>
        <Icon type="search" style={{ fontSize: 16 }} />
        <span>快速搜索</span>
      </Button>
      {process.env.APP_MODE == 'tenant' && (<a href="#"><Badge count={notifyCount} size="small" onClick={navToNotify}>
        <BellTwoTone style={{ fontSize: 16 }} />
      </Badge></a>)}
      <div className={styles.right}>
        <Dropdown trigger={['click']} overlay={menu} placement="bottomRight">
          <div className={styles.userPanel}>
            <Avatar size="small" src={user.get('avatar')} className={styles.avatar} />
            {
              process.env.APP_MODE !== 'tenant' && user.getIn(['manager', 'isWorking']) ? (
                <Badge count={<Icon type="clock-circle" style={{ fontSize: 20, color: '#fd8517' }} />}>
                  <span style={{ paddingRight: 15 }}>{user.get('name')}</span>
                </Badge>
              ) : user.get('name')
            }
            <DownOutlined />
          </div>
        </Dropdown>
      </div>
    </div>
  )
}
